'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.pillifyLinks = pillifyLinks;

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _MatrixClientPeg = require('../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _SettingsStore = require('../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _pushprocessor = require('matrix-js-sdk/lib/pushprocessor');

var _pushprocessor2 = _interopRequireDefault(_pushprocessor);

var _index = require('../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pillifyLinks(nodes, mxEvent) {
    var room = _MatrixClientPeg2.default.get().getRoom(mxEvent.getRoomId());
    var shouldShowPillAvatar = _SettingsStore2.default.getValue("Pill.shouldShowPillAvatar");
    var node = nodes[0];
    while (node) {
        var pillified = false;

        if (node.tagName === "A" && node.getAttribute("href")) {
            var href = node.getAttribute("href");

            // If the link is a (localised) matrix.to link, replace it with a pill
            var Pill = _index2.default.getComponent('elements.Pill');
            if (Pill.isMessagePillUrl(href)) {
                var pillContainer = document.createElement('span');

                var pill = React.createElement(Pill, {
                    url: href,
                    inMessage: true,
                    room: room,
                    shouldShowPillAvatar: shouldShowPillAvatar
                });

                _reactDom2.default.render(pill, pillContainer);
                node.parentNode.replaceChild(pillContainer, node);
                // Pills within pills aren't going to go well, so move on
                pillified = true;

                // update the current node with one that's now taken its place
                node = pillContainer;
            }
        } else if (node.nodeType === Node.TEXT_NODE &&
        // as applying pills happens outside of react, make sure we're not doubly
        // applying @room pills here, as a rerender with the same content won't touch the DOM
        // to clear the pills from the last run of pillifyLinks
        !node.parentElement.classList.contains("mx_AtRoomPill")) {
            var _Pill = _index2.default.getComponent('elements.Pill');

            var currentTextNode = node;
            var roomNotifTextNodes = [];

            // Take a textNode and break it up to make all the instances of @room their
            // own textNode, adding those nodes to roomNotifTextNodes
            while (currentTextNode !== null) {
                var roomNotifPos = _Pill.roomNotifPos(currentTextNode.textContent);
                var nextTextNode = null;
                if (roomNotifPos > -1) {
                    var roomTextNode = currentTextNode;

                    if (roomNotifPos > 0) roomTextNode = roomTextNode.splitText(roomNotifPos);
                    if (roomTextNode.textContent.length > _Pill.roomNotifLen()) {
                        nextTextNode = roomTextNode.splitText(_Pill.roomNotifLen());
                    }
                    roomNotifTextNodes.push(roomTextNode);
                }
                currentTextNode = nextTextNode;
            }

            if (roomNotifTextNodes.length > 0) {
                var pushProcessor = new _pushprocessor2.default(_MatrixClientPeg2.default.get());
                var atRoomRule = pushProcessor.getPushRuleById(".m.rule.roomnotif");
                if (atRoomRule && pushProcessor.ruleMatchesEvent(atRoomRule, mxEvent)) {
                    // Now replace all those nodes with Pills
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)(roomNotifTextNodes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var roomNotifTextNode = _step.value;

                            // Set the next node to be processed to the one after the node
                            // we're adding now, since we've just inserted nodes into the structure
                            // we're iterating over.
                            // Note we've checked roomNotifTextNodes.length > 0 so we'll do this at least once
                            node = roomNotifTextNode.nextSibling;

                            var _pillContainer = document.createElement('span');
                            var _pill = React.createElement(_Pill, {
                                type: _Pill.TYPE_AT_ROOM_MENTION,
                                inMessage: true,
                                room: room,
                                shouldShowPillAvatar: true
                            });

                            _reactDom2.default.render(_pill, _pillContainer);
                            roomNotifTextNode.parentNode.replaceChild(_pillContainer, roomNotifTextNode);
                        }
                        // Nothing else to do for a text node (and we don't need to advance
                        // the loop pointer because we did it above)
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    continue;
                }
            }
        }

        if (node.childNodes && node.childNodes.length && !pillified) {
            pillifyLinks(node.childNodes, mxEvent);
        }

        node = node.nextSibling;
    }
} /*
  Copyright 2019 The Matrix.org Foundation C.I.C.
  
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  */
//# sourceMappingURL=pillify.js.map